// extracted by mini-css-extract-plugin
export default {"adaptiveWheelPreviewBtn":"adaptiveWheelPreviewBtn_adaptiveWheelPreviewBtn__lOYMq","text":"adaptiveWheelPreviewBtn_text__ZGFHs"};